/**
 * greece-order-limit.js
 *
 * 그리스(GR) 배송 통관 규정 대응 스크립트.
 * - 국가 감지: CloudFlare `/cdn-cgi/trace` (cf-ipcountry), 외부 API 불필요.
 * - 비즈니스 룰: 장바구니에 담긴 "서로 다른 상품(라인 아이템)" 최대 3개. 각 상품 수량은 무제한.
 *   - 사이트 첫 진입 시 안내 팝업 1회 노출(세션당 1회, 새로고침마다 X).
 *   - 4번째 신규 상품 add-to-cart 차단 시 안내 팝업 노출(항상).
 *   - 페이지 로드 시 라인 3개 초과면 자동으로 3개로 보정(안전망, 보정 시 안내).
 *
 * 제약(필수):
 * - GR 외 국가는 어떤 동작도 하지 않음(기존 흐름 100% 유지).
 * - Checkout(Global-e 영역)에서는 동작하지 않음.
 * - Global-e 관리 요소(free shipping banner, ATC 버튼, 숨김 요소, 메타필드)는 선택/제거/수정하지 않음.
 *   본 스크립트는 자체 DOM만 추가하고, native `/cart/add` 요청만 검사한다.
 */
(function () {
  'use strict';

  var MAX_PRODUCTS = 3;
  // 적용 대상 국가. 그리스(GR)에서만 동작.
  var TARGET_COUNTRIES = ['GR'];
  var NOTICE_MESSAGE =
    'Shipments to Greece are limited to a maximum of 3 items per order. ' +
    'Please reduce the number of items in your cart to continue.';

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ── Checkout 가드: 결제 단계에서는 절대 동작 금지 ───────────────────────────
  function isCheckout() {
    if (window.Shopify && window.Shopify.Checkout) return true;
    return /\/checkout(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }
  if (isCheckout()) return;

  var greeceConfirmed = false;

  // ── 국가 감지 (CloudFlare cf-ipcountry via /cdn-cgi/trace) ──────────────────
  function parseLoc(text) {
    var match = /(^|\n)loc=([A-Z]{2})/.exec(text || '');
    return match ? match[2] : null;
  }

  function detectCountry() {
    // 세션 캐시 사용(불필요한 반복 호출 방지)
    var cached = null;
    try {
      cached = sessionStorage.getItem('cf_loc');
    } catch (e) {}
    if (cached) return Promise.resolve(cached);

    return fetch('/cdn-cgi/trace', { credentials: 'omit' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (text) {
        var loc = parseLoc(text);
        if (loc) {
          try {
            sessionStorage.setItem('cf_loc', loc);
          } catch (e) {}
        }
        return loc;
      })
      .catch(function () {
        // 감지 실패 시 null → no-op (비-GR 고객을 잘못 막는 사고 방지)
        return null;
      });
  }

  // ── 안내 팝업 (자체 완결형, Global-e/테마 요소 미사용) ──────────────────────
  function injectStyles() {
    if (document.getElementById('greece-order-notice-style')) return;
    var style = document.createElement('style');
    style.id = 'greece-order-notice-style';
    style.textContent =
      '.greece-order-notice__overlay{position:fixed;inset:0;background:rgba(20,20,20,.45);' +
      'z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:16px;}' +
      '.greece-order-notice__box{position:relative;max-width:420px;width:100%;background:#fff;' +
      'border-radius:8px;padding:28px 24px;box-shadow:0 10px 40px rgba(0,0,0,.2);' +
      'font-family:inherit;color:#222;line-height:1.5;text-align:center;}' +
      '.greece-order-notice__msg{font-size:15px;margin:0 0 20px;}' +
      '.greece-order-notice__btn{display:inline-block;border:0;cursor:pointer;' +
      'background:#222;color:#fff;font-size:14px;padding:10px 22px;border-radius:4px;}' +
      '.greece-order-notice__close{position:absolute;top:10px;right:12px;border:0;background:none;' +
      'cursor:pointer;font-size:22px;line-height:1;color:#888;padding:4px;}';
    document.head.appendChild(style);
  }

  function showNotice(message) {
    injectStyles();
    // 이미 떠 있으면 중복 생성 방지
    if (document.querySelector('.greece-order-notice__overlay')) return;

    var overlay = document.createElement('div');
    overlay.className = 'greece-order-notice__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var box = document.createElement('div');
    box.className = 'greece-order-notice__box';

    var close = document.createElement('button');
    close.className = 'greece-order-notice__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';

    var msg = document.createElement('p');
    msg.className = 'greece-order-notice__msg';
    msg.textContent = message || NOTICE_MESSAGE;

    var ok = document.createElement('button');
    ok.className = 'greece-order-notice__btn';
    ok.type = 'button';
    ok.textContent = 'OK';

    box.appendChild(close);
    box.appendChild(msg);
    box.appendChild(ok);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    function dismiss() {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }
    close.addEventListener('click', dismiss);
    ok.addEventListener('click', dismiss);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });
  }

  // ── 장바구니 조회 ──────────────────────────────────────────────────────────
  function getCart() {
    return fetch(rootPath + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  // 추가 요청 body에서 variant id 목록 추출(FormData / URLSearchParams / JSON)
  function extractVariantIds(body) {
    var ids = [];
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        var single = body.get('id');
        if (single) ids.push(String(single));
        // /cart/add.js 의 items[] 배열 형식 (items[0][id] ...)
        if (typeof body.forEach === 'function') {
          body.forEach(function (value, key) {
            if (/items\[\d+\]\[id\]/.test(key) && value) ids.push(String(value));
          });
        }
      } else if (typeof body === 'string') {
        // JSON body
        if (body.charAt(0) === '{' || body.charAt(0) === '[') {
          var json = JSON.parse(body);
          if (json && json.id != null) ids.push(String(json.id));
          if (json && Array.isArray(json.items)) {
            json.items.forEach(function (it) {
              if (it && it.id != null) ids.push(String(it.id));
            });
          }
        } else {
          // urlencoded string
          var params = new URLSearchParams(body);
          var pid = params.get('id');
          if (pid) ids.push(String(pid));
        }
      }
    } catch (e) {}
    return ids;
  }

  // 신규 variant(현재 카트에 없는 상품)를 추가하면서 라인이 3개를 넘는지 검사
  function wouldExceedLimit(addingIds, cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    if (cart.items.length < MAX_PRODUCTS) return false;

    var existing = {};
    cart.items.forEach(function (item) {
      existing[String(item.variant_id || item.id)] = true;
    });
    // 추가하려는 것 중 "현재 카트에 없는 신규 상품"이 하나라도 있으면 4번째가 되어 초과
    for (var i = 0; i < addingIds.length; i++) {
      if (!existing[addingIds[i]]) return true;
    }
    return false;
  }

  // 테마(product-cart.js)가 그대로 표시할 수 있는 422 형태 응답
  function blockedResponse() {
    var payload = JSON.stringify({
      status: 422,
      message: NOTICE_MESSAGE,
      description: NOTICE_MESSAGE
    });
    return new Response(payload, {
      status: 200,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  // ── fetch 래핑: `/cart/add` 요청만, GR 확정 시에만 개입 ─────────────────────
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAddToCart = /\/cart\/add(\.js)?(\?|$)/.test(url);

      if (greeceConfirmed && isAddToCart) {
        var body = init && init.body;
        // Request 객체로 전달된 경우 body 파싱이 어려워 통과(fail-open)
        if (body && (body instanceof FormData || body instanceof URLSearchParams || typeof body === 'string')) {
          var addingIds = extractVariantIds(body);
          if (addingIds.length) {
            return getCart().then(function (cart) {
              if (wouldExceedLimit(addingIds, cart)) {
                showNotice();
                return blockedResponse();
              }
              return nativeFetch(input, init);
            });
          }
        }
      }
    } catch (e) {
      // 어떤 오류든 기존 흐름을 막지 않도록 통과
    }
    return nativeFetch(input, init);
  };

  // ── 페이지 로드 시 자동 보정(안전망): 라인 3개 초과 → 3개로 축소 ────────────
  function reconcileCart() {
    getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || cart.items.length <= MAX_PRODUCTS) return;

      var updates = {};
      cart.items.forEach(function (item, index) {
        // 먼저 담긴 3개 유지, 이후 라인 제거
        if (index >= MAX_PRODUCTS) updates[item.key] = 0;
      });

      fetch(rootPath + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      })
        .then(function () {
          if (window.Alpine && Alpine.store('xMiniCart') && typeof Alpine.store('xMiniCart').reLoad === 'function') {
            Alpine.store('xMiniCart').reLoad();
          } else if (/\/cart(\/|$|\?)/.test(window.location.pathname)) {
            window.location.reload();
          }
          showNotice();
        })
        .catch(function () {});
    });
  }

  // ── 초기화 ─────────────────────────────────────────────────────────────────
  detectCountry().then(function (loc) {
    if (TARGET_COUNTRIES.indexOf(loc) === -1) return; // 대상 국가 외: no-op
    greeceConfirmed = true;

    function onReady() {
      // 사이트 첫 진입 시 1회 안내(세션당 1회). 같은 세션 내 새로고침/이동에는 다시 뜨지 않음.
      // (4번째 상품 추가 차단 시에는 세션 여부와 무관하게 항상 노출됨 — fetch 래퍼 참고)
      var shown = false;
      try {
        shown = sessionStorage.getItem('greece_notice_shown') === '1';
      } catch (e) {}
      if (!shown) {
        showNotice();
        try {
          sessionStorage.setItem('greece_notice_shown', '1');
        } catch (e) {}
      }
      reconcileCart(); // 라인 3개 초과 시에만 자동 보정(+그때 안내)
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }
  });
})();
